
<template>
  <el-row class="imgListFlow">
    <ul class>
      <li v-for="item in topicsList" :key="item.id" :title="item.title">
        <div style="cursor: pointer;" @click="gotoDetail(item.id)">
          <el-image style="width: 280px; height: 280px;" :src="item.surfacePlot" fit="contain"></el-image>
          <h4>{{item.title}}</h4>
        </div>
        <div>
          <button class="cancelFavorite" @click="cancelFavoriteTopic(item.id)">取消</button>
        </div>
      </li>
    </ul>
  </el-row>
</template>

<script>
export default {
  data: function() {
    return {
      topicsList: [{}]
    };
  },
  methods: {
    TopicsCollectList: async function() {
      var res = await this.$http.get("/v1/collect/topicsCollectList?page=1");
      var { code, data, message } = res.data;

      if (code == 0) {
        this.topicsList = data;
        console.log(this.topicsList);
      } else {
        this.$message.error(message);
      }
    },
    // 取消收藏
    cancelFavoriteTopic(picid) {
      this.$confirm("是否取消收藏？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          console.log(picid);
          var clres = await this.$http.post(
            `/v1/collect/collectionTopicsInfo?id=${picid}`
          );
          var { code, message, data } = clres.data;
          if (code == 0) {
            this.$message.success("取消成功");
            this.TopicsCollectList();
          }
          // var is_this = this;
          // clres.then(
          //   function(future) {
          //     var { code, message, data } = future.data;
          //     if (code == 0) {
          //       //alert(data);
          //       //location.reload();
          //       this.VideoCollectList();
          //       is_this.$message({
          //         type: "success",
          //         duration: 1600,
          //         message: data,
          //         onClose: function() {
          //           is_this.$router.go(0);
          //         }
          //       });
          //     }
          //   },
          //   function(error) {}
          // );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    gotoDetail:function(id){
        this.$router.push({
            path:'videodetail',
            query:{
                id:id
            }
        })
    }
  },
  mounted: function() {
    this.TopicsCollectList();
  }
};
</script>

<style scoped >
@import "../../../../assets/css/imgListFlow.css";
</style>


// WEBPACK FOOTER //
// src/components/personalcenter/common/fartabpane/topics.vue